// @ts-nocheck
import { NavigatorMessage, UserID } from "@cruisen/contract"
import { timestampToDate } from "@cruisen/react-shared"

const messageTypesToBeMerged = ["userLikedTripSearchResult", "navigatorCruiseRecommendation"]

type MessageWithDisplayProperties = NavigatorMessage & {
  showMessageDate: boolean
  showAvatarAndName: boolean
}

export const mergeNavigatorMessages = (
  messages: NavigatorMessage[],
  userId: UserID,
): MessageWithDisplayProperties[] => {
  const newMessages: NavigatorMessage[] = []

  for (let i = 0; i < messages.length; i++) {
    const currentMessage = messages[i]
    const previousMessage = i > 0 ? newMessages[newMessages.length - 1] : null

    if (currentMessage.source === "user" && !currentMessage.type) {
      continue
    }

    if (
      Array.isArray(currentMessage.data?.excludeUserIds) &&
      currentMessage.data.excludeUserIds.includes(userId) &&
      currentMessage.data?.notification?.data?.userId !== userId
    ) {
      continue
    }

    const showMessageDate =
      !previousMessage ||
      timestampToDate(previousMessage.timestamp) !== timestampToDate(currentMessage.timestamp)

    const showAvatarAndName =
      !previousMessage ||
      previousMessage.source !== currentMessage.source ||
      showMessageDate ||
      previousMessage.userId !== currentMessage.userId

    if (!messageTypesToBeMerged.includes(currentMessage.type)) {
      newMessages.push({
        ...currentMessage,
        showMessageDate,
        showAvatarAndName,
      })
      continue
    }

    const mergedCruises = [currentMessage.data?.notification?.data]
    let j = i + 1

    while (
      j < messages.length &&
      messages[j]?.type === currentMessage.type &&
      messages[j]?.data?.notification?.data?.userId ===
        currentMessage?.data?.notification?.data?.userId
    ) {
      mergedCruises.push(messages[j].data?.notification?.data)
      j++
    }

    if (mergedCruises.length > 1) {
      const mergedMessage: NavigatorMessage = {
        ...currentMessage,
        data: {
          ...currentMessage.data,
          notification: {
            ...currentMessage.data.notification,
            data: {
              ...currentMessage.data.notification.data,
              cruises: mergedCruises,
            },
          },
        },
        showMessageDate,
        showAvatarAndName,
      }
      newMessages.push(mergedMessage)
      i = j - 1
    } else {
      newMessages.push({
        ...currentMessage,
        showMessageDate,
        showAvatarAndName,
      })
    }
  }

  return newMessages.reverse()
}
